// Direct React component imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCards } from "swiper";
// import CampaignsCarouselMobile
import { CarouselMobileItem } from "./CarouselMobileItem";
import { CarouselFormItem } from "./CarouselFormItemMobile";
import { Button } from "@mantine/core";
import Link from "next/link";

import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/lazy";

const CampaignsCarouselMobile = ({
  recentCampaigns,
  campaignLoading,
  feature,
}) => {
  const mostRecentCampaigns = recentCampaigns.slice(0, 5);

  return (
    <div className="my-10 flex flex-col  ">
      <Swiper
        effect={"cards"}
        loop={true}
        // slidesPerView='auto'
        // maxBackfaceHiddenSlides={0}
        loopedSlides={5}
        loopAdditionalSlides={5}
        speed={1000}
        // lazy={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        modules={[EffectCards, Autoplay]}
        className="h-96 w-60 md:w-64"
      >
        {mostRecentCampaigns.map((camp, slideIndex) => {
          return (
            <SwiperSlide
              key={slideIndex}
              className="flex items-center justify-center rounded-sm"
            >
              {campaignLoading ? (
                <p>Loading</p>
              ) : camp.type === "FORM" ? (
                <CarouselFormItem campaign={camp} feature={feature} />
              ) : (
                <CarouselMobileItem campaign={camp} feature={feature} />
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div
        className={
          feature
            ? "hidden w-full justify-center"
            : "flex w-full justify-center"
        }
      >
        <Link href="/airdrops?type=ALL&page=1">
          <Button className="btn-sec mt-14 w-48 bg-accent text-black hover:bg-accent hover:bg-opacity-20">
            Explore More Campaigns
          </Button>
        </Link>
      </div>
    </div>
  );
};
export default CampaignsCarouselMobile;
